<app-banner-app [retroSelected]=false></app-banner-app>

<div style="background-color: #DFEAFF;">
    <br>
    <div class="container">
        <br><br><br><br>
        <div class="row contenido">
            <div class="col">
                <div class="textoArriba">
                    <br><br>
                    <div>
                        <p class="texto2">El inmueble es propiedad de una<br>
                            persona políticamente expuesta.</p>
                        <p class="texto1">Seguimos trabajando para ofrecerte más opciones.</p>
                    </div>
                    <br>
                    <img src="./assets/img/CancelacionSeguro.png" [width]="1" [height]="1" priority />
                </div>
                <div class="textoAbajo">
                    <img src="./assets/img/CancelacionSeguro.png" [width]="1" [height]="1" priority />
                    <br><br><br>
                    <div>
                        <h3 class="texto2">Lo sentimos</h3>
                        <h5 class="texto1">En este momento no estamos preparados para asegurar tu viaje.<br>
                            Seguimos trabajando para ofrecerte más opciones.
                        </h5>
                    </div>
                </div>
                <br><br>

                <div class="container tamanioBoton">
                    <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" (click)="volverInicio()">
                        Volver al inicio
                    </button>
                </div>
            </div>
        </div>
    </div>

    <br><br><br><br>
    <app-footer-app />

</div>